// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"4f9dfec7","425":"479b6cd1","514":"4fc41457","796":"007002cd"}[chunkId] + ".chunk.js";
};